import { doGet, doPost, doPatch, doDelete } from 'src/api/client';

export async function reqGetBanners() {
  return doGet('banner');
}

export async function reqGetActiveBanners() {
  return doGet('banner/active');
}

export async function reqCreateBanner(payload) {
  return doPost('banner', payload);
}

export async function reqUpdateBanner(id, payload) {
  return doPatch(`banner/${id}`, payload);
}

export async function reqDeleteBanner(id) {
  return doDelete(`banner/${id}`);
}
